"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sensor32053Bss101LensTable = void 0;
const lens_table_1 = require("../lens-table");
const angle = [
    0.00,
    0.76,
    1.51,
    2.27,
    3.02,
    3.78,
    4.54,
    5.29,
    6.05,
    6.80,
    7.56,
    8.32,
    9.07,
    9.83,
    10.58,
    11.34,
    12.10,
    12.85,
    13.61,
    14.36,
    15.12,
    15.87,
    16.63,
    17.39,
    18.14,
    18.90,
    19.65,
    20.41,
    21.17,
    21.92,
    22.68,
    23.43,
    24.19,
    24.95,
    25.70,
    26.46,
    27.21,
    27.97,
    28.73,
    29.48,
    30.24,
    30.99,
    31.75,
    32.51,
    33.26,
    34.02,
    34.77,
    35.53,
    36.29,
    37.04,
    37.80,
    38.55,
    39.31,
    40.07,
    40.82,
    41.58,
    42.33,
    43.09,
    43.85,
    44.60,
    45.36,
    46.11,
    46.87,
    47.62,
    48.38,
    49.14,
    49.89,
    50.65,
    51.40,
    52.16,
    52.92,
    53.67,
    54.43,
    55.18,
    55.94,
    56.70,
    57.45,
    58.21,
    58.96,
    59.72,
    60.48,
    61.23,
    61.99,
    62.74,
    63.50,
    64.26,
    65.01,
    65.77,
    66.52,
    67.28,
    68.04,
    68.79,
    69.55,
    70.30,
    71.06,
    71.82,
    72.57,
    73.33,
    74.08,
    74.84,
    75.59,
];
const rp /* pixel radius in mm */ = [
    0.00,
    0.02,
    0.04,
    0.06,
    0.09,
    0.11,
    0.13,
    0.15,
    0.17,
    0.19,
    0.21,
    0.24,
    0.26,
    0.28,
    0.30,
    0.32,
    0.34,
    0.36,
    0.39,
    0.41,
    0.43,
    0.45,
    0.47,
    0.49,
    0.51,
    0.53,
    0.56,
    0.58,
    0.60,
    0.62,
    0.64,
    0.66,
    0.68,
    0.70,
    0.72,
    0.75,
    0.77,
    0.79,
    0.81,
    0.83,
    0.85,
    0.87,
    0.89,
    0.91,
    0.93,
    0.96,
    0.98,
    1.00,
    1.02,
    1.04,
    1.06,
    1.08,
    1.10,
    1.12,
    1.14,
    1.16,
    1.18,
    1.20,
    1.22,
    1.24,
    1.26,
    1.28,
    1.30,
    1.32,
    1.34,
    1.36,
    1.38,
    1.40,
    1.42,
    1.44,
    1.46,
    1.48,
    1.50,
    1.52,
    1.54,
    1.56,
    1.58,
    1.60,
    1.61,
    1.63,
    1.65,
    1.67,
    1.69,
    1.71,
    1.73,
    1.74,
    1.76,
    1.78,
    1.80,
    1.82,
    1.83,
    1.85,
    1.87,
    1.88,
    1.90,
    1.92,
    1.94,
    1.95,
    1.97,
    1.99,
    2.00,
];
exports.sensor32053Bss101LensTable = new lens_table_1.LensTable(angle, rp);
